// --------------------------------
// Copyright (c) 2023 Eco8 S.r.l.
// --------------------------------
import React, { useState } from "react";
import { View, Text, TouchableOpacity, TextInput } from "react-native";
import styles from "../../../../../styles/Farmer/NumberSelectorStyle";

const NumberSelector = ({ size, onChange, quantity, max, trips }) => {
    // serve il max?
    if (trips) {
        max = 5;
    } else if (!max) {
        max = size === 'big' ? 12000 : 70;
    }

    const [number, setNumber] = useState(quantity);
    const [isEditing, setIsEditing] = useState(false);
    const [inputText, setInputText] = useState("");

    const handleEditClick = () => {
        setIsEditing(true);
        setInputText(String(number));
    };

    const handleInputTextChange = (text) => {
        setInputText(text);
    };

    const handleInputSubmit = () => {
        const parsedNumber = parseFloat(inputText);
        if (!isNaN(parsedNumber)) {
            setNumberOnChange(parsedNumber);
        }
        setIsEditing(false);
    };

    const setNumberOnChange = (newNumber) => {
        setNumber(newNumber);
        onChange(newNumber);
    }

    const incrementNumber = () => {
        if (trips) {
            setNumberOnChange(Math.min(number + 1, max));
        } else if (size === "big") {
            setNumberOnChange(Math.min(number + 1000, max));
        } else if (size === "small") {
            setNumberOnChange(Number(Math.min(number + 5, max)).toFixed(1))
        } else {
            console.log("Farmer::NumberSelector: size unknown")
        }
    };

    const decrementNumber = () => {
        if (trips) {
            setNumberOnChange(Math.max(number - 1, 0));
        } else if (size === "big") {
            setNumberOnChange(Math.max(number - 1000, 0));
        } else if (size === "small") {
            setNumberOnChange(Number(Math.max(number - 5, 0)).toFixed(1));
        } else {
            console.log("Farmer::NumberSelector: size unknown")
        }
    };

    return (
        <View style={styles.container}>
            <TouchableOpacity style={styles.button} onPress={decrementNumber}>
                <View>
                    <Text style={styles.text}>-</Text>
                </View>
            </TouchableOpacity>
            {!isEditing ? (
                <TouchableOpacity style={styles.label} onPress={handleEditClick}>
                    <Text style={styles.text}>{number}</Text>
                </TouchableOpacity>
            ) : (
                <TextInput
                    style={styles.editableLabel}
                    value={inputText}
                    onChangeText={handleInputTextChange}
                    onBlur={handleInputSubmit}
                    autoFocus
                    keyboardType="numeric"
                />
            )}
            <TouchableOpacity style={styles.button} onPress={incrementNumber}>
                <View>
                    <Text style={styles.text}>+</Text>
                </View>
            </TouchableOpacity>
        </View>
    );
};

export default NumberSelector;
